import React from 'react';
const SkeletonCard = () => <div className="rounded-xl border border-[#E5E7EB] bg-white p-4 shadow-sm animate-pulse" data-id="element-511" data-mp="2wxn2nalpbk7a">
    <div className="flex items-center gap-3" data-id="element-512" data-mp="2x6v3b2jae7d">
      <div className="w-10 h-10 rounded-full bg-[#F3F4F6]" data-id="element-513" data-mp="3u49li0ajsggj" />
      <div className="flex-1 space-y-2" data-id="element-514" data-mp="3u4rpxk7d60zj">
        <div className="h-3 w-28 rounded bg-[#E5E7EB]" data-id="element-515" data-mp="3p56tbgfo24pz" />
        <div className="h-2.5 w-36 rounded bg-[#F3F4F6]" data-id="element-516" data-mp="3p6q812loc7pn" />
      </div>
    </div>
    <div className="mt-4 grid grid-cols-[auto,1fr] gap-5 items-center" data-id="element-517" data-mp="qmhy6z7cwkoo">
      <div className="pr-5 border-r border-[#E5E7EB] space-y-2" data-id="element-518" data-mp="lopy3hwk5s9e">
        <div className="h-8 w-12 rounded bg-[#E5E7EB]" data-id="element-519" data-mp="lmdfd2iz7dva" />
        <div className="h-2.5 w-16 rounded bg-[#F3F4F6]" data-id="element-520" data-mp="gobzeqgujuo1" />
      </div>
      <div className="space-y-3" data-id="element-521" data-mp="bqistwbmsyn8">
        {[0, 1, 2].map(i => <div key={i} className="h-1.5 w-full rounded-full bg-[#F3F4F6]" data-id="element-522" data-mp="bsd56m8u7ifp" />)}
      </div>
    </div>
    <div className="mt-4 h-8 rounded-lg bg-[#F3F4F6]" data-id="element-523" data-mp="31d81nlvwtwqo" />
  </div>;
export const NeuroSkeleton = () => <div className="space-y-8" aria-busy="true" aria-label="Loading cognitive readiness" data-id="element-524" data-mp="2wiucw2br6nuz">
    {[0, 1].map(section => <div key={section} data-id="element-525" data-mp="1ozmzrsmvlr2x">
        <div className="flex items-center gap-2 mb-3 animate-pulse" data-id="element-526" data-mp="1oyvh1iednnu2">
          <div className="w-6 h-6 rounded-full bg-[#E5E7EB]" data-id="element-527" data-mp="1a2w865jg1jnv" />
          <div className="h-3.5 w-40 rounded bg-[#E5E7EB]" data-id="element-528" data-mp="1a4qkivgng3gc" />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-529" data-mp="1f0fmf5g55wft">
          {[0, 1, 2, 3].map(i => <SkeletonCard key={i} data-id="element-530" data-mp="118rcn8td7k20" />)}
        </div>
      </div>)}
  </div>;
export default NeuroSkeleton;